import { render, staticRenderFns } from "./FilesListHeaderButton.vue?vue&type=template&id=e85a09d2&"
import script from "./FilesListHeaderButton.vue?vue&type=script&lang=ts&"
export * from "./FilesListHeaderButton.vue?vue&type=script&lang=ts&"
import style0 from "./FilesListHeaderButton.vue?vue&type=style&index=0&id=e85a09d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports